import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  accountId: null,
  type: null,
  lists: {},
  metadata: {},
  verticalId: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
